/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronsDoubleDown: {
  name: 'chevrons-double-down';
  data: string;
} = {
  name: 'chevrons-double-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.707 6.293a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L12 9.586 8.707 6.293Zm0 6a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L12 15.586l-3.293-3.293Z" fill="currentColor"/></svg>`,
};
